<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="alert-wrapper">
                <alert-container :messages="msgs" />
            </div>
            <div class="page">
                <div class="exportacao-dados vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('exportacao-dados') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a>{{ isVenda ? $t('vendas') : $t('agro') }}</a>
                                    </li>
                                    <li>
                                        <a>{{ $t('relatorios') }}</a>
                                    </li>
                                    <li>
                                        <a href="#" aria-current="page">{{
                                            $t('exportacao-dados')
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div class="form-columns-fit">
                        <div class="columns">
                            <!-- margin-top 0; pq o columns por padrão tem margem negativa -->
                            <!-- PESQUISA -->
                            <div class="column is-6">
                                <search-bar
                                    :onSearch="debouncedOnSearch"
                                />
                            </div>
                            <div class="column is-3">
                                <verified-date-picker
                                    dateType="startDate"
                                    :value="filter.datainicial"
                                    :endDate="filter.datafinal"
                                    title="data-inicio"
                                    @input="changeStartDate"
                                />
                            </div>
                            <div class="column is-3">
                                <verified-date-picker
                                    dateType="endDate"
                                    :value="filter.datafinal"
                                    :startDate="filter.datainicial"
                                    title="data-fim"
                                    @input="changeEndDate"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="columns is-multiline search-filters">
                        <!-- SITUAÇÃO -->
                        <div class="column is-5">
                            <label>{{ $t('situacao') }}</label>
                            <s-select
                                class="is-100"
                                label="descricao"
                                :value="filter.situacao"
                                :options="situacoes"
                                :selectHeight="40"
                                placeholder="Todos"
                                :loading="situacaoLoading"
                                @input="updateValue($event, 'situacao')"
                                clearable
                            >
                            </s-select>
                        </div>

                        <!-- ORIGEM/TIPO GRUPO -->
                        <div class="column is-5">
                            <label>{{ $t('origem') }}</label>
                            <s-select
                                class="is-100"
                                label="descricao"
                                :value="filter.origem"
                                :options="origens"
                                :selectHeight="40"
                                placeholder="Todos"
                                :loading="origemLoading"
                                @search="carregarOrigens"
                                @input="updateValue($event, 'origem')"
                                searchable
                                clearable
                            >
                            </s-select>
                        </div>
                        <div class="column is-2">
                            <b-button
                                class="mt-5"
                                type="is-primary"
                                icon-right="magnify"
                                @click="carregarDados()"
                                :disabled="isLoading"
                            >
                                {{ $t('recarregar') }}
                            </b-button>
                        </div>
                    </div>

                    <div class="exportacoes-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            class="data-table"
                            :data="exportacoes ? exportacoes : []"
                            @sort="updateSort"
                            backend-sorting
                            backend-pagination
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.label != '' ? $t(f.label) : ''"
                                :sortable="f.sortable"
                                :width="f.width"
                                :centered="f.centered"
                                v-slot="props"
                            >
                                <template slot="header">
                                    <span v-if="f.key == 'solicitante'">
                                        {{ $t('solicitante') }}
                                    </span>
                                    <span v-else>
                                        {{ f.label ? $t(f.label) : '-' }}
                                    </span>
                                </template>
                                <div v-if="f.key == 'situacao'" class="no-strike">
                                    <b-tag :type="statusColor(props.row.situacao)">
                                        {{ $t(props.row.situacao.toLowerCase()) }}
                                    </b-tag>
                                </div>
                                <div v-else-if="f.key == 'acao'" class="no-strike">
                                    <div
                                        v-if="props.row.situacao.toLowerCase() == 'finalizada'"
                                        class="exportIcons"
                                    >
                                        <div
                                            v-if="props.row.processoexportado == 'pdf'"
                                            class="export-icon"
                                            @click="downloadArchive(props.row, 'application/pdf')"
                                        >
                                            <b-icon
                                                icon="file-pdf"
                                                class="is-medium is-clickable"
                                                v-tippy 
                                                :title="$t('msg-tooltip-pdf-download')"
                                            />
                                        </div>
                                        <div
                                            v-if="props.row.processoexportado == 'excel'"
                                            class="export-icon"
                                            @click="
                                                downloadArchive(
                                                    props.row,
                                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                                )
                                            "
                                        >
                                            <b-icon
                                                icon="file-excel"
                                                class="is-medium is-clickable"
                                                v-tippy 
                                                :title="$t('msg-tooltip-excel-download')"
                                            />
                                        </div>
                                        <div
                                            v-if="props.row.processoexportado == 'csv'"
                                            class="export-icon"
                                            @click="
                                                downloadArchive(props.row, [
                                                    'text/csv',
                                                    'application/vnd.ms-excel',
                                                ])
                                            "
                                        >
                                            <b-icon
                                                icon="file"
                                                class="is-medium is-clickable"
                                                v-tippy 
                                                :title="$t('msg-tooltip-csv-download')"
                                            />
                                        </div>
                                        <div class="export-icon" @click="openModalEmail(props.row)">
                                            <b-icon
                                                icon="email-outline"
                                                class="is-medium is-clickable"
                                                v-tippy 
                                                :title="$t('msg-tooltip-email')"
                                            />
                                        </div>
                                        <div
                                            class="export-icon"
                                            @click="openModalWhatsapp(props.row)"
                                        >
                                            <b-icon
                                                icon="whatsapp"
                                                class="is-medium is-clickable"
                                                v-tippy 
                                                :title="$t('msg-tooltip-whatsapp')"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-else-if="props.row.situacao.toLowerCase() == 'exportando'"
                                        class="exportIcons"
                                    >
                                        <div
                                            class="export-icon"
                                            @click="confirmExclusion(props.row)"
                                        >
                                            <b-icon
                                                icon="delete-outline"
                                                class="is-medium is-clickable"
                                                v-tippy 
                                                :title="$t('msg-tooltip-delete')"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div v-else-if="f.key == 'titulo'">
                                    {{ props.row.titulo ? props.row.titulo : '—' }}
                                </div>

                                <div v-else-if="f.key == 'descricaogrupo'">
                                    {{
                                        props.row.exportacaoTipoGrupo
                                            ? props.row.exportacaoTipoGrupo.descricao
                                            : '—'
                                    }}
                                </div>

                                <div v-else-if="f.key == 'dataHora'">
                                    {{
                                        props.row.datahorasolicitacao
                                            ? $moment(props.row.datahorasolicitacao).format('L LT')
                                            : '—'
                                    }}
                                </div>
                                <div v-else-if="f.key == 'origem'">
                                    {{
                                        props.row.exportacaotipo
                                            ? props.row.exportacaotipo.chaveenum
                                            : '-'
                                    }}
                                </div>
                                <div v-else-if="f.key == 'solicitante'">
                                    {{ props.row.usuario ? props.row.usuario.nome : '-' }}
                                </div>
                                <div v-else>
                                    <router-link
                                        :to="{
                                            name: isVenda
                                                ? 'relatorio-exportacao-detalhes'
                                                : 'relatorio-agro-exportacao-detalhes',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        {{ props.row[f.key] }}
                                    </router-link>
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                        <!-- MODAL DADOS DO E-MAIL -->
                        <b-modal
                            class="modal-email"
                            :active.sync="isShowingEmail"
                            style="z-index: 1000"
                            @close="onCancelModal()"
                        >
                            <div class="modal-card modal-default center">
                                <container-loader v-if="isLoadingModal" />
                                <section class="modal-card-body">
                                    <div class="listing-header">
                                        <div class="title-breadcrumb">
                                            <h1 class="title">
                                                {{ $t('exportacao-dados-email') }}
                                            </h1>
                                        </div>
                                    </div>
                                    <div class="columns is-full mt-2 px-3">
                                        <div class="input-50">
                                            <v-input
                                                v-model="emailDestino"
                                                :maxlength="100"
                                                :type="'email'"
                                                :title="'email-destino'"
                                                :msg="invalidEmailMsg"
                                                :invalid="invalidEmail"
                                                :onBlurFunction="validateEmailInner"
                                                :uppercase="false"
                                            />
                                        </div>
                                    </div>
                                    <div class="columns is-full px-3">
                                        <div class="input-50">
                                            <v-input
                                                v-model="emailAssunto"
                                                :maxlength="100"
                                                :type="'email'"
                                                :title="'assunto-email'"
                                                :uppercase="false"
                                            />
                                        </div>
                                    </div>

                                    <div class="columns is-full px-3">
                                        <div class="input-full">
                                            <v-textarea
                                                ref="obsGeralTextArea"
                                                v-model="emailConteudo"
                                                class="obs-ta"
                                                :title="'conteudo-email'"
                                                :maxlength="1000"
                                                disableTransform
                                            />
                                        </div>
                                    </div>
                                    <div class="columns ok">
                                        <div class="form-buttons2">
                                            <button
                                                class="delete-btn"
                                                type="button"
                                                @click="onCancelModal()"
                                            >
                                                {{ $t('cancelar') }}
                                            </button>
                                            <button
                                                class="save-btn"
                                                type="button"
                                                @click="sendEmail()"
                                            >
                                                {{ $t('enviar-email') }}
                                            </button>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </b-modal>

                        <!-- MODAL DADOS ENVIOS WHATSAPP -->
                        <b-modal
                            class="modal-whatsapp"
                            :active.sync="isShowingWhatsapp"
                            style="z-index: 1000"
                            @close="onCancelModal()"
                        >
                            <div class="modal-card modal-default center">
                                <container-loader v-if="isLoadingModal" />
                                <section class="modal-card-body">
                                    <div class="listing-header">
                                        <div class="title-breadcrumb">
                                            <h1 class="title">
                                                {{ $t('exportacao-dados-whatsapp') }}
                                            </h1>
                                        </div>
                                    </div>
                                    <div class="columns is-full mt-2 px-3">
                                        <div class="input-50">
                                            <v-input-tel
                                                ref="whatsAppInput"
                                                v-model="whatsappInput"
                                                title="whatsapp-destino"
                                                :edit="checkEditTel(whatsappInput)"
                                                @input="validateWhatsapp"
                                                :msg="invalidWhatsappMsg"
                                                :invalid="invalidWhatsapp"
                                                @inputValidate="inputValidate"
                                            />
                                        </div>
                                    </div>
                                    <div class="columns is-full px-3">
                                        <div class="input-full">
                                            <v-textarea
                                                ref="obsGeralTextArea"
                                                v-model="whatsappConteudo"
                                                class="obs-ta"
                                                :title="'conteudo-whatsapp'"
                                                :maxlength="1000"
                                                disableTransform
                                                :invalid="invalidWhatsapp"
                                                :onBlurFunction="validateWhatsapp"
                                            />
                                        </div>
                                    </div>
                                    <div class="columns ok">
                                        <div class="form-buttons2">
                                            <button
                                                class="delete-btn"
                                                type="button"
                                                @click="onCancelModal()"
                                            >
                                                {{ $t('cancelar') }}
                                            </button>
                                            <button
                                                class="save-btn"
                                                type="button"
                                                @click="sendWhatsapp()"
                                            >
                                                {{ $t('enviar-whatsapp') }}
                                            </button>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ExportacaoService from '@/services/ExportacaoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import ExportacaoTipoGrupoService from '@/services/ExportacaoTipoGrupoService';
import Message from '@/models/Message';
import ExportacaoLogService from '@/services/ExportacaoLogService';
import { mapState } from 'vuex';
import allCountries from '@/assets/all-countries.js';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('relatorio-exportacao') && to.name != 'relatorio-exportacao-dados') {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    data() {
        return {
            exportacoes: [],
            service: new ExportacaoService(this.$http, this.$router),
            serviceTipoGrupo: new ExportacaoTipoGrupoService(this.$http, this.$router),
            exportacaoLogService: new ExportacaoLogService(this.$http, this.$router),
            fields: [
                {
                    key: 'id',
                    label: 'codigo',
                    sortable: true,
                    width: 100,
                    centered: true,
                    vcenter: true,
                },
                { key: 'titulo', label: 'titulo', sortable: true },
                { key: 'descricaogrupo', label: 'origem', sortable: true },
                { key: 'solicitante', label: 'solicitante', sortable: true },
                { key: 'dataHora', label: 'data-hora', sortable: true },
                {
                    key: 'situacao',
                    label: 'situacao',
                    sortable: false,
                    width: 100,
                    centered: true,
                    vcenter: true,
                },
                { key: 'acao', label: 'acao', sortable: false, centered: true },
            ],
            currentPage: 1,
            perPage: 20,
            exportacaoSelecionada: '',
            emailDestino: '',
            msgs: [],
            emailAssunto: '',
            emailConteudo: '',
            isShowingEmail: false,
            whatsappInput: null,
            whatsappDestino: '',
            whatsappConteudo: '',
            isShowingWhatsapp: false,
            totalRows: 0,
            isLoading: false,
            isEmpty: false,
            isLoadingModal: false,
            invalidEmail: false,
            invalidEmailMsg: 'msg-campo-obrigatorio',
            invalidWhatsapp: true,
            validPhoneFormat: false,
            invalidWhatsappMsg: 'msg-campo-obrigatorio',
            query: '',
            tipo: 'h',
            situacoes: [
                { value: 0, descricao: 'EXPORTANDO' },
                { value: 1, descricao: 'FINALIZADA' },
                { value: 2, descricao: 'EXCLUIDA' },
            ],
            situacaoLoading: false,
            origens: [],
            origemLoading: false,
            filter: {
                situacao: null,
                origem: null,
                status: '',
                datainicial: null,
                datafinal: null,
            },
            sort: 'id',
            order: 'desc',
            ini: '',
            fim: '',
            delete: null,
            permissao: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            datasStart: {
                datainicial: (() => {
                    let trintaDiasAtras = new Date();
                    trintaDiasAtras.setDate(trintaDiasAtras.getDate() - 31);
                    return trintaDiasAtras;
                })(),
                datafinal: new Date(),
            },
            isVenda: 'vendas' === this.$route.meta.contexto ? true : false,
        };
    },
    created() {
        if (
            this.$route.name.includes('relatorio-exportacao') &&
            this.$route.name != 'relatorio-exportacao-dados'
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.setStartDates();
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.isVenda
            ? this.hasPermissionAccess('vendas', 'exportacao-dados', 'relatorio-exportacao-dados')
            : this.hasPermissionAccess('agro', 'relatorios', 'relatorio-agro-exportacao-dados');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'exportacao-dados' },
            });

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
        this.carregarOrigens('');
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        setStartDates() {
            this.filter.datainicial = this.datasStart.datainicial;
            this.filter.datafinal = this.datasStart.datafinal;
        },
        changeStartDate(date) {
            this.filter.datainicial = date;
            this.carregarDados();
        },
        changeEndDate(date) {
            this.filter.datafinal = date;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (this.isLoading) return;
            this.isLoading = true;

            let filtro = {
                query: this.query,
                idusuarioerp: this.$store.state.user.idusuarioerp,
                situacao: this.filter.situacao ? this.filter.situacao.descricao : null,
                exportacaoTipoGrupo: this.filter.origem ? this.filter.origem : null,
                datainicial: this.filter.datainicial
                    ? this.$moment(this.filter.datainicial).format('YYYY-MM-DD')
                    : null,
                datafinal: this.filter.datafinal
                    ? this.$moment(this.filter.datafinal).format('YYYY-MM-DD')
                    : null,
            };
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.service
                .findAll(
                    filtro,
                    this.sort,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.query
                )
                .then((r) => {
                    this.pagination.totalRows = r.totalElements;
                    this.exportacoes = r.content;
                    this.isEmpty = this.exportacoes.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    console.error('Erro ao carregar exportações.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        // Salva os dados na tabela fvw_exportacaolog
        saveLog(s, dest) {
            let exportacaoLog = {
                ///Objeto criado que será enviado ao banco
                destino: dest,
                acao: s,
                exportacao: this.exportacaoSelecionada,
                usuario: {
                    idusuarioerp: this.exportacaoSelecionada.usuario.idusuarioerp,
                },
            };
            this.exportacaoLogService
                .save(exportacaoLog)
                .then((r) => {})
                .catch((e) => {
                    console.error('Erro ao salvar log exportação.', e);
                    this.$root.showMessage('error', 'msg-erro-exp-gerar');

                    if (rethrow) {
                        throw e;
                    }
                })
                .finally((_) => {
                    this.isSaving = false;
                });
        },

        //ExportacaoTipoGrupo
        carregarOrigens(searchQuery) {
            this.isLoading = true;
            this.serviceTipoGrupo
                .findAll(0, 50, searchQuery)
                .then((r) => {
                    this.origens = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de atividades. Termo: [${searchQuery}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        openModalEmail(item) {
            this.isShowingEmail = true;
            this.exportacaoSelecionada = item;
        },
        openModalWhatsapp(item) {
            this.isShowingWhatsapp = true;
            this.exportacaoSelecionada = item;
            this.whatsappConteudo = process.env.VUE_APP_API_URL + this.exportacaoSelecionada.url;
        },
        onSearch(value) {
            this.query = this.removeAcentos(value);
            this.currentPage = 1;
            this.carregarDados(this.pagination.currentPage);
        },
        statusColor(s) {
            switch (s.toUpperCase()) {
                case 'FINALIZADA':
                    return 'is-success';
                case 'EXECUTANDO':
                    return 'is-warning';
                case 'EXCLUIDA':
                    return 'is-danger';
                default:
                    return 'is-info';
            }
        },
        // Valida se o e-mail é valido
        validateEmailInner() {
            if (this.emailDestino && this.validateEmail(this.emailDestino)) {
                this.invalidEmail = false;
            } else {
                this.invalidEmail = true;
                this.invalidEmailMsg = 'msg-campo-invalido';
            }
        },
        downloadArchive(exp, tipo) {
            //Pega o indice da ultima barra da url
            let n = exp.url.lastIndexOf('/');
            // Pega o texto que fica após a ultima barra, no caso nome do arquivo
            let fileName = exp.url.substring(n + 1);

            this.service.downloadArchive(exp.url).then((r) => {
                let blob = new Blob([r.data], { type: tipo });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                setTimeout(function () {
                    window.URL.revokeObjectURL(blob);
                }, 100);
            });
        },
        //Validação do número de destino
        inputValidate(val) {
            this.validPhoneFormat = val != undefined && val.valid ? true : false;
        },
        validateWhatsapp() {
            let split = this.whatsappInput.split(' ');
            let code = allCountries.filter((c) => c.iso2 == split[0].toUpperCase())[0];
            if (code != undefined && this.whatsappInput != '') {
                this.whatsappDestino = code.dialCode + split[1];
                if (this.validPhoneFormat) {
                    if (code.dialCode == 55) {
                        this.invalidWhatsapp = split[1].length == 11 ? false : true;
                    } else {
                        this.invalidWhatsapp = false;
                    }
                }
            } else {
                this.invalidWhatsapp = true;
            }
            if (this.invalidWhatsapp) {
                this.invalidWhatsappMsg = 'msg-campo-invalido';
            }
        },
        //Realiza o envio do e-mail
        sendEmail() {
            if (!this.invalidEmail && this.emailDestino) {
                let mail = {
                    assunto: this.emailAssunto,
                    conteudoHtml: this.emailConteudo,
                    destino: this.emailDestino,
                    urlAnexo: this.exportacaoSelecionada.url,
                };
                this.isLoadingModal = true;
                this.service
                    .enviarEmail(mail)
                    .then((r) => {
                        this.$root.showMessage('success', 'msg-email-sucess');
                        this.onCancelModal();
                    })
                    .catch((e) => {
                        console.error('Erro ao enviar o e-mail.');
                    })
                    .finally((_) => {
                        this.isLoadingModal = false;
                    });
            } else {
                this.validateEmailInner();
                this.$root.showMessage('alert', 'msg-email-invalido');
            }
        },
        updateValue(v, filtro) {
            switch (filtro) {
                case 'situacao':
                    this.filter.situacao = v;
                    break;
                case 'origem':
                    this.filter.origem = v;
                    break;
                case 'datainicial':
                    this.filter.datainicial = v;
                    break;
                case 'datafinal':
                    this.filter.datafinal = v;
                    break;
                default:
                    break;
            }
            this.carregarDados();
        },
        excluir() {
            this.isLoading = true;
            this.service
                .delete(this.deleteThis.id)
                .then((_) => {
                    this.$root.showMessage('success', 'msg-delete-sucess');
                })
                .catch((e) => {
                    console.error('Erro ao excluir subgrupo.', e);
                    this.$root.showMessage('error', 'msg-failure-excluir-export');
                })
                .finally((_) => {
                    this.deleteThis = null;
                    this.pagination.totalRows = 0;
                    this.exportacoes = [];
                    this.isEmpty = true;
                    setTimeout(() => {
                        this.isLoading = false;
                        this.carregarDados(this.pagination.currentPage);
                    }, 200);
                });
        },
        confirmExclusion(item) {
            this.deleteThis = item;
            this.$root.confirm({
                message: this.$t('msg-confirmacao-exclusao-n', { n: item.titulo }),
                onConfirm: (_) => this.excluir(),
                onCancel: (_) => (this.deleteThis = null),
            });
        },
        updateSort(sort, order) {
            this.sort = sort;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        setToday(tipoData) {
            if (tipoData == 'inicio') {
                this.filter.datainicial = new Date();
                this.currentPage = 1;
                this.carregarDados(this.pagination.currentPage);
            } else {
                this.filter.datafinal = new Date();
                this.currentPage = 1;
                this.carregarDados(this.pagination.currentPage);
            }
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        onCancelModal() {
            this.emailDestino = '';
            this.emailAssunto = '';
            this.emailConteudo = '';
            this.isShowingEmail = false;
            this.whatsappDestino = '';
            this.whatsappConteudo = '';
            this.isShowingWhatsapp = false;
        },
        //Envio da mensagem Whatsapp
        sendWhatsapp() {
            if (!this.invalidWhatsapp && this.whatsappDestino) {
                this.saveLog('Envio do arquivo via whatsapp', this.whatsappDestino);
                const link = document.createElement('a');
                link.href = `http://api.whatsapp.com/send?phone=${this.whatsappDestino}&text=${this.whatsappConteudo}`;
                link.target = '_blank';
                link.click();
            } else {
                this.$root.showMessage('alert', 'msg-whatsapp-invalido');
            }
        },
        checkEditTel(val) {
            return (
                this.$route.params.id &&
                val != null &&
                val != '' &&
                val != ' ' &&
                val != undefined &&
                val != 'null'
            );
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;

    .page {
        position: relative;
        padding-left: 0;
        .exportIcons {
            display: flex;
            justify-content: center;
        }
        .export-icon {
            color: var(--primary-color);
        }

        .form-buttons2 {
            top: 20px;
            display: flex;
            margin: 0 auto;
            .save-btn,
            .delete-btn {
                display: flex;
                justify-content: center;
                align-items: center;
                color: $sovis-white;
                font-size: 12px;
                height: 47px;
                padding: 15px 40px;
                border: none;
                border-radius: 6px;
                font-weight: 600;
                margin-left: 20px !important;
                @include gradient-button();
            }
            .delete-btn {
                right: 225px;
                color: $darker-gray-color;
                @include exclude-button();
            }
        }
        .input-full {
            width: 100%;
            text-align: left;
        }
        .input-75 {
            width: 75%;
            text-align: left;
        }
        .input-50 {
            width: 50%;
            text-align: left;
        }
        .input-25 {
            width: 25%;
            text-align: left;
        }

        .save-btn,
        .delete-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            color: $sovis-white;
            font-size: 12px;
            height: 40px;
            padding: 15px 40px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            margin-left: 20px !important;
            @include gradient-button();
        }

        .delete-btn {
            right: 225px;
            color: $darker-gray-color;
            @include exclude-button();
        }

        .modal {
            display: flex;
            justify-content: center;
        }
        .ok {
            margin: 0;
        }
        .modal-content {
            width: 40% !important;
        }
        .modal-card {
            width: auto !important;
            max-width: 700px;
        }
        .size-textarea {
            height: 200px;
        }
        .control-bar {
            margin-bottom: 0;
            .date-opts {
                margin-bottom: 0.5rem !important;
            }
            .date-group {
                justify-content: center;
                flex-wrap: wrap;
            }
        }
    }

    .obs-ta {
        flex-grow: 1;
        min-height: 250px;
    }
}
</style>
